import { render, staticRenderFns } from "./CashflowCategories.vue?vue&type=template&id=f2f09a9c&lang=pug&"
import script from "./CashflowCategories.vue?vue&type=script&lang=ts&"
export * from "./CashflowCategories.vue?vue&type=script&lang=ts&"
import style0 from "./CashflowCategories.vue?vue&type=style&index=0&id=f2f09a9c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports